module.exports = __webpack_public_path__ + "static/media/HAPAG-LLOYD.d7dcd87b.svg";